module.exports = __webpack_public_path__ + "static/media/social-sci.1cfb713d.jpg";